/**
 * IDからカテゴリの情報を返す
 * @param {Number} id カテゴリID
 * @param {String} type どの情報を取得するか（'slug'か'name'）
 * @param {Array} categories カテゴリ一覧
 */
const catData = (id, type, categories) => {
    if (!categories.length) return;

    for (const val of categories) {
        if (val.id !== id) continue;
        if (type === 'slug') return val.slug;
        if (type === 'name') return val.name;
    }
}

export default catData